import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const UpdateIcon = ({
  width = "24",
  height = "24",
  color = "#4C545B",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.37766 14.668C6.39775 17.3987 8.93366 19.3333 11.9004 19.3333C15.7663 19.3333 18.9004 16.05 18.9004 12M18.4231 9.332C17.4043 6.60067 14.8678 4.66667 11.9004 4.66667C8.03448 4.66667 4.90039 7.95 4.90039 12M9.9913 14.6667H4.90039V20M18.9004 4V9.33333H13.8095"
          stroke={color}
          strokeWidth="2"
        />
      </svg>
    </IconWrapper>
  );
};
